export enum A00070TertiaryButtonSmallType {
    A = 'a',
    B = 'b'
}

export interface A00070TertiaryButtonSmall {
    text: string;
    modifier: A00070TertiaryButtonSmallType;
}
